/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { withMemo, css } from 'fierry/react.old';

import Placement from 'galax/react/map/hex/placement';

import Background from 'galax/react/map/hex/background';
import Borders from 'galax/react/map/hex/borders';

import Flows from 'galax/react/map/zone/flows';
import Entity from 'galax/react/map/entity';

import AttackBeacon from 'galax/react/map/beacon/attack';
import TransferBeacon from 'galax/react/map/beacon/transfer';
import WinnerNotOwnerBeacon from 'galax/react/map/beacon/winner.not.owner';


import * as EnergyValue from 'galax/value/energy';
import * as InfluenceValue from 'galax/value/influence';


const getBackgroundOpacity = ({ location }) =>
{
  const value = EnergyValue.toPercentage(location.getZone().getType().getEnergy(location.getZone().getUserID())) / 100;

  if (value >= 0.95) { return 0.00; }
  if (value >= 0.80) { return 0.05; }
  if (value >= 0.60) { return 0.10; }
  if (value >= 0.50) { return 0.15; }
  if (value >= 0.40) { return 0.20; }
  if (value >= 0.20) { return 0.25; }

  return 0.4;
}


const ExternalStyle = ({ hexGeometry }) => css`

  stroke: var(--svg-always-black);

  stroke-width: ${hexGeometry.getUserBorderWidth()};
`;


const SectorStyle = ({ hexGeometry, borderGeometry }) => css`

  stroke: var(--svg-always-black);

  stroke-width: ${hexGeometry.getSectorBorderWidth()};
  stroke-dasharray: ${borderGeometry.getDasharray(3)};
`;


const ZoneStyle = ({ hexGeometry }) => css`

  stroke: var(--svg-always-black);

  stroke-width: ${hexGeometry.getZoneBorderWidth()};
`;


const ZoneBackground = ({ containerRef, ...props }) =>
(
  <Placement {...props} containerRef = {containerRef} index = {0} >

      <Background {...props} primaryColor
        opacityValue = {getBackgroundOpacity(props)}
      />

      <WinnerNotOwnerBeacon {...props} />

      <Borders {...props}
        externalStyle = {ExternalStyle}
        sectorStyle = {SectorStyle}
        zoneStyle = {ZoneStyle}
      />

  </Placement>
);


const ZoneDirections = ({ containerRef, ...props }) =>
(
  <Placement {...props} containerRef = {containerRef} index = {1} >

    <Flows {...props} />

  </Placement>
);


const ZoneForeground = ({ containerRef, ...props }) =>
(
  <Placement {...props} containerRef = {containerRef} index = {2} >

    <Entity {...props} />

    <AttackBeacon {...props} />
    <TransferBeacon {...props} />

  </Placement>
);


const Component = (props) =>
(
  <>
    <ZoneBackground {...props} />
    <ZoneDirections {...props} />
    <ZoneForeground {...props} />
  </>
);


export default withMemo(props =>
{
  return <Component {...props} location = {props.zone.getLocation()} />;
});
